<template>
    <section class="legal-section">
        <div class="container">
            <h1 class="legal-title">Terms & Conditions</h1>
            <p class="legal-intro">
                These Terms and Conditions ("Terms") govern your access to and use of the HarashFit website (harashfit.com) and related services. By accessing or using the site, you agree to comply with these Terms.
            </p>

            <h2>1. Use of Website</h2>
            <p>
                The content provided on this website is for general informational and personal fitness purposes. You agree not to use the website for unlawful or harmful activities, or in any manner that could damage, disable, or interfere with the operation of the platform.
            </p>

            <h2>2. User Accounts</h2>
            <p>
                To access certain features or purchase subscriptions, you may be required to create an account. You are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your account.
            </p>

            <h2>3. Payment and Subscriptions</h2>
            <p>
                Our services may be offered on a subscription basis. By subscribing, you agree to provide accurate payment information and authorize us to charge your chosen payment method. Subscription details, pricing, and renewal policies are provided on our pricing page and may be updated with notice.
            </p>

            <h2>4. Intellectual Property</h2>
            <p>
                All content, including but not limited to text, videos, logos, images, and training programs, is owned by HarashFit or its licensors. You may not reproduce, distribute, or modify any part of the site without prior written permission.
            </p>

            <h2>5. Health Disclaimer</h2>
            <p>
                The information and programs on HarashFit are for educational purposes only and are not intended to replace professional medical advice. Always consult a healthcare provider before starting a new fitness regimen.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
                We are not liable for any damages, injuries, or losses resulting from your use of the site or services, including fitness activities or advice followed. Use of the platform is at your own risk.
            </p>

            <h2>7. Termination</h2>
            <p>
                We reserve the right to suspend or terminate your access to the platform at any time, without notice, for violations of these Terms or misuse of our services.
            </p>

            <h2>8. Modifications</h2>
            <p>
                We may revise these Terms periodically. The latest version will always be available on this page, and continued use of the site constitutes your acceptance of any changes.
            </p>

            <h2>9. Governing Law</h2>
            <p>
                These Terms shall be governed by and construed in accordance with the laws applicable in your country of residence or operation. Any disputes will be resolved in accordance with applicable local laws and in competent local courts.
            </p>

            <h2>10. Contact</h2>
            <p>
                For any questions or concerns regarding these Terms, please contact us at:<br />
                <strong>Email:</strong> info@harashfit.com<br />
                <strong>Phone:</strong> +962 7 9060 6181
            </p>

            <p class="legal-footer">
                Last updated: May 2025
            </p>
        </div>
    </section>
</template>


<style scoped>
.legal-section {
    padding: 10px 20px;
    color: #f0f0f0;
    min-height: 100vh;
    line-height: 1.7;
    font-size: 15px;
}

.container {
    max-width: 900px;
    margin: auto;
}

.legal-title {
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 20px;
    text-align: center;
}

.legal-intro {
    font-size: 16px;
    margin-bottom: 30px;
    color: #dddddd;
}

h2 {
    margin-top: 32px;
    font-size: 22px;
    color: #ff5555;
}

p {
    margin-bottom: 16px;
    color: #cccccc;
}

.legal-footer {
    margin-top: 40px;
    font-size: 14px;
    color: #aaa;
}
</style>